import React from 'react';

const AppDownloadBanner = () => null;

export default AppDownloadBanner;
